"use strict";
exports.__esModule = true;
exports.FlexAnywhereGenericPortal = exports.OONBillerGenericPortal = exports.FlexAnywherePortalName = exports.OON_BILLER_ID = exports.IntegrationType = exports.BillerPropertyStatus = void 0;
var BillerPropertyStatus;
(function (BillerPropertyStatus) {
    BillerPropertyStatus["ACTIVE"] = "ACTIVE";
    BillerPropertyStatus["INACTIVE"] = "INACTIVE";
})(BillerPropertyStatus = exports.BillerPropertyStatus || (exports.BillerPropertyStatus = {}));
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["DIRECT_INTEGRATION"] = "DIRECT_INTEGRATION";
    IntegrationType["PORTAL"] = "PORTAL";
    IntegrationType["FLEX_ANYWHERE"] = "FLEX_ANYWHERE";
    IntegrationType["EMBED"] = "EMBED";
    /**
     * @deprecated
     *  you shouldn't expect biller to return this as an integration type in the future (1/3/2024)
     */
    IntegrationType["YARDI"] = "YARDI";
    /**
     * @deprecated
     *  you shouldn't expect biller to return this as an integration type in the future (1/3/2024)
     */
    IntegrationType["REALPAGE"] = "REALPAGE";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
exports.OON_BILLER_ID = 'recyyKh2nQxY0iNCA';
var FlexAnywherePortalName;
(function (FlexAnywherePortalName) {
    FlexAnywherePortalName["OUT_OF_NETWORK"] = "Out of Network";
    FlexAnywherePortalName["FLEX_ANYWHERE"] = "Flex Anywhere";
})(FlexAnywherePortalName = exports.FlexAnywherePortalName || (exports.FlexAnywherePortalName = {}));
/** @deprecated use BillerFlexAnywherePortal and set the public_id from the api instead */
exports.OONBillerGenericPortal = {
    public_id: exports.OON_BILLER_ID,
    portal_name: FlexAnywherePortalName.OUT_OF_NETWORK,
    display_name: FlexAnywherePortalName.OUT_OF_NETWORK,
    status: BillerPropertyStatus.ACTIVE,
    portal_display_config: undefined
};
exports.FlexAnywhereGenericPortal = {
    public_id: exports.OON_BILLER_ID,
    portal_name: FlexAnywherePortalName.FLEX_ANYWHERE,
    display_name: FlexAnywherePortalName.FLEX_ANYWHERE,
    status: BillerPropertyStatus.ACTIVE,
    portal_display_config: undefined
};
